<template>
  <div class="menu-wrapper">
    <template v-if="!(item.children && item.children.length > 0)">
      <app-link :to="resolvePath(item.fullPath)">
        <el-menu-item
          :index="resolvePath(item.fullPath)"
          :class="{ 'submenu-title-noDropdown': !isNest }"
        >
          <!-- <item v-if="item.parentFuncCode" :icon="item.icon" :title="item.name" />
          <item v-else :title="item.name" icon="example" /> -->
          <item :title="item.name" :icon="item.icon" />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else :index="resolvePath(item.fullPath)">
      <template slot="title">
        <item :title="item.name" :icon="item.icon" />
      </template>

      <template v-for="child in item.children">
        <sidebar-item-to-menu
          v-if="child.children && child.children.length > 0"
          :key="child.id"
          :is-nest="true"
          :item="child"
          :base-path="resolvePath(child.fullPath)"
          class="nest-menu"
        />

        <app-link
          v-else
          :key="child.id"
          :to="resolvePath(child.fullPath, child)"
        >
          <el-menu-item :index="resolvePathIndex(child.fullPath, child)">
            <span v-if="child.name.length > 10">
              <el-tooltip
                effect="light"
                :content="child.name"
                placement="right"
              >
                <span><item :icon="''" :title="child.name" /></span>
              </el-tooltip>
            </span>
            <span v-else>
              <item :icon="''" :title="child.name" />
            </span>
          </el-menu-item>
        </app-link>
      </template>
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import { generateTitle } from '@/common/utils/i18n'
import { isExternal } from '@/common/utils'
import Item from './Item'
import AppLink from './Link'
import FixiOSBug from './FixiOSBug'

export default {
  name: 'SidebarItemToMenu',
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      onlyOneChild: null
    }
  },
  methods: {
    hasOneShowingChild(children, parent) {
      const showingChildren = children.filter((item) => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    /**
     * 跳转地址处理
     *  质量统计的地址就外链， 跳转地址/statistics/:id?
     *
     **/

    resolvePath(routePath, router) {
      if (isExternal(routePath)) {
        return path.resolve(
          this.basePath,
          'statistics/' + router.id + '?url=' + encodeURIComponent(routePath)
        )
      }
      return path.resolve(this.basePath, routePath)
    },
    /**
     * 跳转地址处理index
     *  质量统计的地址就外链， :index 只做回显，不做跳转 index不用跟后面的参数 /statistics/:id
     *目前暂只做了二级
     **/
    resolvePathIndex(routePath, router) {
      if (isExternal(routePath)) {
        return path.resolve(this.basePath, '/statistics/' + router.id)
      }
      return path.resolve(this.basePath, routePath)
    },

    generateTitle
  }
}
</script>
